import api from "../../Http/global-vars";
import { FETCH_ADMINS } from "../types";

export const fetchAdmins = () => {
  return async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${window.sessionStorage.getItem("userToken")}`,
      },
    };
    const url = api + "adminuser/";
    await fetch(url, config)
      .then(async (res) => {
        const data = await res.json();
        // console.log("data categories", data)
        dispatch({
          type: FETCH_ADMINS,
          payload: data.results
            .filter((user) => !user?.is_archived)
            .sort((a, b) => b?.id - a?.id),
        });
      })
      .catch((error) => console.log("error", error?.response));
  };
};
